import {z} from 'zod';

export const additionalInformationValueTypeSchema = z.enum([
  'string',
  'date',
  'dateTime',
  'boolean',
]);

export const additionalInformationItemSchema = z.object({
  id: z.string().nullable(),
  code: z.string().nullable(),
  value: z.record(z.unknown()).nullable(),
  valueType: additionalInformationValueTypeSchema,
  isEditable: z.boolean().nullable(),
});

export const getServiceVehicleAdditionalInformationApiArgSchema = z.object({
  serviceVehicleId: z.string(),
});

export const getServiceVehicleAdditionalInformationApiResSchema = z.array(
  additionalInformationItemSchema
);

export const patchServiceVehicleAdditionalInformationApiArgSchema = z.object({
  serviceVehicleId: z.string(),
  additionalInformationId: z.string(),
  patchAdditionalInformationRequestBody: z.object({
    value: z.string().nullable(),
  }),
});

export const patchServiceVehicleAdditionalInformationApiResSchema = z.void();

export type AdditionalInformationValueType = z.infer<typeof additionalInformationValueTypeSchema>;
export type AdditionalInformationItem = z.infer<typeof additionalInformationItemSchema>;
export type GetServiceVehicleAdditionalInformationApiArg = z.infer<
  typeof getServiceVehicleAdditionalInformationApiArgSchema
>;
export type GetServiceVehicleAdditionalInformationApiRes = z.infer<
  typeof getServiceVehicleAdditionalInformationApiResSchema
>;
export type PatchServiceVehicleAdditionalInformationApiArg = z.infer<
  typeof patchServiceVehicleAdditionalInformationApiArgSchema
>;
export type PatchServiceVehicleAdditionalInformationApiRes = z.infer<
  typeof patchServiceVehicleAdditionalInformationApiResSchema
>;
